<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
  <h5>Signin with Google to access the Firebase database</h5>
  <br>
  <div class="row">
    <div class="col-md-6">
      <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
    </div>
  </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h1 style="display:inline-block">Exercises</h1>
  <span style="font-size:0.9em;color:gray;margin-left:12px">({{exercises.length}})</span>
  <i class="bi bi-question-circle" style="font-size: 1.5em;margin-left:20px;color:gray" (click)="showinfo = !showinfo"></i>
  <button class="btn btn-primary" (click)="edit(null)" style="float: right;margin-top:10px">Add Exercise</button>
  <br>
  Remove old exercises before a certain date:
  <div class="inline">
    <sa-input-text [(text)]="sStartDate" [title]="'Cutoff Date' "></sa-input-text>
  </div>
  <button class="btn btn-primary" (click)="checkBeforeDate()" style="margin-right:10px;margin-top:10px">Check Exercises</button>
  <button class="btn btn-danger" (click)="removeCheckedExercises()" style="margin-right:10px;margin-top:10px">Remove Checked Exercises</button>

  <br>
  <div *ngIf="showinfo" style="margin:20px;padding:20px;background-color:lightgray;border:solid 1px gray">
    An exercise is a collaborative event where a teacher leads students through a virtual experience called a Virtex exercise.
    Both the teacher and students are associated with a unique identifier called the exercise ID.
    This ID links them specifically to the exercise, ensuring that only participants who possess the correct exercise ID can join.
    As a result, the exercise remains secure and accessible only to authorized participants.
  </div>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Id</th>
        <th>Edit</th>
        <th>Check</th>
        <th>Name <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(exercises,'name',sortArray)"></i></th>

        <th>Organization <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(exercises,'organization',sortArray)"></i></th>
        <th>ScenarioId <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(exercises,'scenarioid',sortArray)"></i></th>
        <th>NPlayers <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(exercises,'nPlayers',sortArray)"></i></th>
        <th>Start Date <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(exercises,'startdate',sortArray)"></i></th>
        <th>Start Date 2<i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(exercises,'dStartDate',sortArray)"></i></th>
        <th>Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let e of exercises">
        <td>{{e.id}}</td>
        <td><i class="bi bi-pencil" style="color:orange" (click)="edit(e)"></i></td>
        <td><sa-input-boolean [(checked)]="e.checked"></sa-input-boolean></td>
        <td>{{e.name}}</td>
        <td>{{e.organization}}</td>
        <td>{{e.scenarioid}}</td>
        <td>{{e.nPlayers}}</td>
        <td>{{e.startdate}}</td>
        <td>{{e.dStartDate | date:'YYYY-MM-dd'}}</td>
        <td><i class="bi bi-trash" style="color:orange" (click)="remove(e)"></i></td>
      </tr>
    </tbody>
  </table>
</div>